import React, {useEffect, useState} from "react";
import Tracker from "../../../components/Tracker";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {useDispatch, useSelector} from "react-redux";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import {
  classResponsiveForm,
  classResponsiveFormDoubleWidth,
  ERRORFIELDREQUIRED,
  optionsEstados
} from "../../../data/ConstantForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {CalendarFormRange} from "../../../components/ComponentesFormularios/CalendarForm";
import {isEmpty} from "../../../util/is";
import {
  dateToStringFormat,
  getFechaToCalendarRange,
  validArray,
  validateDiasEntregaVisita, validObjectKeys
} from "../../../util/functions";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {Colors} from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import CheckBox from "../../../components/ComponentesFormularios/CheckBox";


const Informacion = ({isEditing = true, id}) => {

  const generalServicesState = useSelector( state => state.generalServices );
  const { register, handleSubmit, formState: { errors }, control } = useFormContext();

  const onSuccessSubmit = (data) => {
      Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id);
  }

  const onErrorSubmit = (error) => {

  }

  useEffect(() => {
    register("dtFechaIniFin", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-end py-2">
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>


      <div className="row mx-0 px-0 mt-3 mb-2">

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="txPortafolio" label="Nombre Portafolio"
                 placeholder="Ej: ASISTENCIA MOVIL"  type="text" required={true} className={`${classResponsiveFormDoubleWidth}`}
                 customError={errors.txPortafolio ? ERRORFIELDREQUIRED : null}/>

      <CalendarFormRange inputProps={{control}} disabled={!isEditing} identificador="dtFechaIniFin" required={true}
                         label="Fecha Ingreso - Salida" className={`${classResponsiveFormDoubleWidth}`}
                         customError={errors.dtFechaIniFin ? ERRORFIELDREQUIRED : null}/>

      <SelectForm inputProps={{control}} disabled={!isEditing} identificador="idSegmento" label="Segmento"
                  options={generalServicesState?.arrSegmentos}  required={true} className={`${classResponsiveForm}`}
                  customError={errors.idSegmento ? ERRORFIELDREQUIRED : null} />

      <SelectForm inputProps={{control}} disabled={!isEditing} identificador="idModeloAtencion" label="Modelo Atención"
                  options={generalServicesState?.arrModelosAtencion}  required={true} className={`${classResponsiveForm}`}
                  customError={errors.idSegmento ? ERRORFIELDREQUIRED : null} />

      <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="idEstado" options={optionsEstados} required={true}
                       defaultValue="1" label="Estado" className={`w-auto`}
                       customError={errors.idEstado ? ERRORFIELDREQUIRED : null}/>

      </div>

    </div>
  )

}

const CheckBoxCategorias = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsCategorias = useWatch({
    control,
    name: 'jsCategorias'
  });

  const handleChangeCheckBoxCategorias = ({name: id, checked, label}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsCategorias', {});
        return;
      }

      let jsCategoriasAll = {};

      for(let item of validArray(generalServicesState?.arrCategoriasProductos)){

        jsCategoriasAll[item.id] = {
          id: item.id,
          name: label,
          checked: true
        }

      }

      setValue('jsCategorias', jsCategoriasAll);

      return;
    }

    if(!checked){

      let jsCategoriasClone = Object.assign({}, validObjectKeys(jsCategorias));
      let i = 0;
      for(let item in jsCategoriasClone){

        if(id === item){
          delete jsCategoriasClone[item];
          break;
        }

        i++;
      }

      setValue('jsCategorias', jsCategoriasClone);

      return;
    }

    let jsCategoriasClone = Object.assign({}, validObjectKeys(jsCategorias));

    jsCategoriasClone[id] = {id, checked, name: label};

    setValue('jsCategorias', jsCategoriasClone);

  }

  useEffect(() => {
    console.log(jsCategorias)
  }, [jsCategorias])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

      <div className="position-relative mx-1">
        <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxCategorias({name, checked})}/>
      </div>

      <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                 placeholder="Buscar Categoria..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

    </div>

      <div className="row mx-3 px-0 mt-3 mb-2">
      {
        generalServicesState?.arrCategoriasProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map((item) => (
          item.id &&
          <div className={classResponsiveForm}>
            <CheckBox identificador={item.id} label={item.text} value={!isEmpty(jsCategorias[item.id])} styleLabel={{width: 120}} onChange={({name, checked, label}) => handleChangeCheckBoxCategorias({name, checked, label})}/>
          </div>
        ))
      }
    </div>

    </div>
  )

}

const Categorias = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsCategorias = getValues('jsCategorias');

    if(Object.keys(jsCategorias)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 categoria"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsCategorias', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsCategorias");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las categorias para asignar al portafolio</h4>

      <CheckBoxCategorias />


    </div>
  )

}

const CheckBoxSubCategorias = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsCategorias = useWatch({
    control,
    name: 'jsCategorias'
  });

  const jsSubCategorias = useWatch({
    control,
    name: 'jsSubCategorias'
  });

  const handleChangeCheckBoxSubCategorias = ({name: id, checked, label, checkAllCat}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsSubCategorias', {});
        return;
      }

      let jsSubCategoriasAll = {};

      for(let item of validArray(generalServicesState?.arrSubCategoriasProductos)){
        if(!isEmpty(jsCategorias[item.idPadre])){
          jsSubCategoriasAll[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }
      }

      for(let itemCategorias in validObjectKeys(jsCategorias)){

        jsSubCategoriasAll[itemCategorias] = {
          id: jsCategorias[itemCategorias].id,
          name: jsCategorias[itemCategorias].name,
          checked: true,
          padre: true
        }

      }

      setValue('jsSubCategorias', jsSubCategoriasAll);

      return;
    }

    if(checkAllCat){

      let jsSubCategoriasCheckAllCat = Object.assign({}, validObjectKeys(jsSubCategorias));

      if(!checked){

        for(let item of validArray(generalServicesState?.arrSubCategoriasProductos)){

          if(item.idPadre === id){
            for(let itemState in jsSubCategoriasCheckAllCat){
              if(item.id === itemState){
                delete jsSubCategoriasCheckAllCat[itemState];
              }
            }
          }

        }
        setValue('jsSubCategorias', jsSubCategoriasCheckAllCat);
        return;
      }

      for(let item of validArray(generalServicesState?.arrSubCategoriasProductos)){

        if(item.idPadre === id){
          jsSubCategoriasCheckAllCat[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      setValue('jsSubCategorias', jsSubCategoriasCheckAllCat);


      return;
    }

    if(!checked){

      let jsSubCategoriasClone = Object.assign({}, validObjectKeys(jsSubCategorias));
      let i = 0;
      for(let item in jsSubCategoriasClone){

        if(id === item){
          delete jsSubCategoriasClone[item];
          break;
        }

        i++;
      }

      setValue('jsSubCategorias', jsSubCategoriasClone);

      return;
    }

    let jsSubCategoriasClone = Object.assign({}, validObjectKeys(jsSubCategorias));

    jsSubCategoriasClone[id] = {id, checked, name: label};

    setValue('jsSubCategorias', jsSubCategoriasClone);

  }

  useEffect(() => {
    console.log(jsSubCategorias)
  }, [jsSubCategorias])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

        <div className="position-relative mx-1">
          <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxSubCategorias({name, checked})}/>
        </div>

        <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                   placeholder="Buscar Sub Categoria..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

      </div>

      <div className="my-2">
        {
            Object.keys(validObjectKeys(jsCategorias)).map((item) => (
              <div className="container px-0">
                <div className="w-100 bg-gray-200 p-2 d-flex align-items-center justify-content-between">
                  <div className="font-weight-bold">
                    <CheckBox identificador={`${jsCategorias[item]?.id}`} value={jsSubCategorias[item]?.checked}
                              styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={``}
                              onChange={({name, checked, label}) => handleChangeCheckBoxSubCategorias({
                                name,
                                checked,
                                label: jsCategorias[item]?.name,
                                checkAllCat: true
                              })}/>
                    {jsCategorias[item]?.name}
                  </div>
                  <i data-toggle="collapse" data-target={`#collapseSubCategorias${jsCategorias[item]?.id}`}
                     aria-expanded="true" aria-controls={`#collapseSubCategorias${jsCategorias[item]?.id}`}
                     className="fas fa-chevron-down fa-lg p-1 cursor-pointer"/>
                </div>
                <div className="row mx-3 px-0 my-3 collapse show" id={`collapseSubCategorias${jsCategorias[item]?.id}`}>
                  {
                    generalServicesState?.arrSubCategoriasProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map(itemSubCategoria => (
                      <>
                        {
                          itemSubCategoria?.idPadre === jsCategorias[item]?.id &&
                          <div className={`${classResponsiveForm} mx-1`}>
                            <CheckBox identificador={itemSubCategoria.id} label={itemSubCategoria.text}
                                      value={!isEmpty(jsSubCategorias[itemSubCategoria.id])} styleLabel={{width: 130}}
                                      onChange={({name, checked, label}) => handleChangeCheckBoxSubCategorias({
                                        name,
                                        checked,
                                        label
                                      })}/>
                          </div>
                        }
                      </>
                    ))
                  }
                </div>
              </div>
            ))
        }
      </div>

      <div className="row mx-3 px-0 mt-3 mb-2">

      </div>

    </div>
  )

}

const SubCategorias = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsSubCategorias = getValues('jsSubCategorias');

    if(Object.keys(jsSubCategorias)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 marca"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsSubCategorias', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsSubCategorias");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las sub categorias para asignar al portafolio</h4>

      <CheckBoxSubCategorias />

    </div>
  )

}

const CheckBoxLinea = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsSubCategorias = useWatch({
    control,
    name: 'jsSubCategorias'
  });

  const jsLinea = useWatch({
    control,
    name: 'jsLinea'
  });

  const handleChangeCheckBoxLinea = ({name: id, checked, label, checkAllLin}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsLinea', {});
        return;
      }

      let jsLineaAll = {};

      for(let item of validArray(generalServicesState?.arrLineaProductos)){
        if(!isEmpty(jsSubCategorias[item.idPadre])) {
          jsLineaAll[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      for(let itemLinea in validObjectKeys(jsSubCategorias)){

        jsLineaAll[itemLinea] = {
          id: jsSubCategorias[itemLinea].id,
          name: jsSubCategorias[itemLinea].name,
          checked: true,
          padre: true
        }

      }

      setValue('jsLinea', jsLineaAll);

      return;
    }

    if(checkAllLin){

      let jsLineaCheckAllLin = Object.assign({}, validObjectKeys(jsLinea));

      if(!checked){

        for(let item of validArray(generalServicesState?.arrLineaProductos)){

          if(item.idPadre === id){
            for(let itemState in jsLineaCheckAllLin){
              if(item.id === itemState){
                delete jsLineaCheckAllLin[itemState];
              }
            }
          }

        }
        setValue('jsLinea', jsLineaCheckAllLin);
        return;
      }

      for(let item of validArray(generalServicesState?.arrLineaProductos)){

        if(item.idPadre === id){
          jsLineaCheckAllLin[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      setValue('jsLinea', jsLineaCheckAllLin);


      return;
    }

    if(!checked){

      let jsLineaClone = Object.assign({}, validObjectKeys(jsLinea));
      let i = 0;
      for(let item in jsLineaClone){

        if(id === item){
          delete jsLineaClone[item];
          break;
        }

        i++;
      }

      setValue('jsLinea', jsLineaClone);

      return;
    }

    let jsLineaClone = Object.assign({}, validObjectKeys(jsLinea));

    jsLineaClone[id] = {id, checked, name: label};

    setValue('jsLinea', jsLineaClone);

  }

  useEffect(() => {
    console.log(jsLinea)
  }, [jsLinea])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

        <div className="position-relative mx-1">
          <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxLinea({name, checked})}/>
        </div>

        <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                   placeholder="Buscar Linea..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

      </div>

      <div className="my-2">
        {
            Object.keys(validObjectKeys(jsSubCategorias)).map((item) => (
              <div className="container px-0">
                <div className="w-100 bg-gray-200 p-2 d-flex align-items-center justify-content-between">
                  <div className="font-weight-bold">
                    <CheckBox identificador={`${jsSubCategorias[item]?.id}`} value={jsLinea[item]?.checked} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={``} onChange={({name, checked, label}) => handleChangeCheckBoxLinea({name, checked, label: jsSubCategorias[item]?.name, checkAllLin: true})}/>
                    {jsSubCategorias[item]?.name}
                  </div>
                  <i data-toggle="collapse" data-target={`#collapseLineas${jsSubCategorias[item]?.id}`} aria-expanded="true" aria-controls={`#collapseLineas${jsSubCategorias[item]?.id}`} className="fas fa-chevron-down fa-lg p-1 cursor-pointer"/>
                </div>
                <div className="row mx-3 px-0 my-3 collapse show" id={`collapseLineas${jsSubCategorias[item]?.id}`}>
                  {
                    generalServicesState?.arrLineaProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map(itemLinea => (
                      <>
                        {
                          itemLinea?.idPadre === jsSubCategorias[item]?.id &&
                          <div className={`${classResponsiveForm} mx-1`}>
                            <CheckBox identificador={itemLinea.id} label={itemLinea.text} value={!isEmpty(jsLinea[itemLinea.id])} styleLabel={{width: 130}} onChange={({name, checked, label}) => handleChangeCheckBoxLinea({name, checked, label})}/>
                          </div>
                        }
                      </>
                    ))
                  }
                </div>
              </div>
            ))
        }
      </div>
      <div className="row mx-3 px-0 mt-3 mb-2">

      </div>

    </div>
  )

}

const Linea = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsLinea = getValues('jsLinea');

    if(Object.keys(jsLinea)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 marca"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsLinea', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsLinea");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las lineas para asignar al portafolio</h4>

      <CheckBoxLinea />

    </div>
  )

}

const CheckBoxSubLinea = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsLinea = useWatch({
    control,
    name: 'jsLinea'
  });

  const jsSubLinea = useWatch({
    control,
    name: 'jsSubLinea'
  });

  const handleChangeCheckBoxSubLinea = ({name: id, checked, label, checkAllSubLin}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsSubLinea', {});
        return;
      }

      let jsSubLineaAll = {};

      for(let item of validArray(generalServicesState?.arrSubLineaProductos)){
        if(!isEmpty(jsLinea[item.idPadre])) {
          jsSubLineaAll[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      for(let itemLinea in validObjectKeys(jsLinea)){

        jsSubLineaAll[itemLinea] = {
          id: jsLinea[itemLinea].id,
          name: jsLinea[itemLinea].name,
          checked: true,
          padre: true
        }

      }

      setValue('jsSubLinea', jsSubLineaAll);

      return;
    }

    if(checkAllSubLin){

      let jsSubLineaCheckAllSubLin = Object.assign({}, validObjectKeys(jsSubLinea));

      if(!checked){

        for(let item of validArray(generalServicesState?.arrSubLineaProductos)){

          if(item.idPadre === id){
            for(let itemState in jsSubLineaCheckAllSubLin){
              if(item.id === itemState){
                delete jsSubLineaCheckAllSubLin[itemState];
              }
            }
          }

        }
        setValue('jsSubLinea', jsSubLineaCheckAllSubLin);
        return;
      }

      for(let item of validArray(generalServicesState?.arrSubLineaProductos)){

        if(item.idPadre === id){
          jsSubLineaCheckAllSubLin[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      setValue('jsSubLinea', jsSubLineaCheckAllSubLin);


      return;
    }

    if(!checked){

      let jsSubLineaClone = Object.assign({}, validObjectKeys(jsSubLinea));
      let i = 0;
      for(let item in jsSubLineaClone){

        if(id === item){
          delete jsSubLineaClone[item];
          break;
        }

        i++;
      }

      setValue('jsSubLinea', jsSubLineaClone);

      return;
    }

    let jsSubLineaClone = Object.assign({}, validObjectKeys(jsSubLinea));

    jsSubLineaClone[id] = {id, checked, name: label};

    setValue('jsSubLinea', jsSubLineaClone);

  }

  useEffect(() => {
    console.log(jsSubLinea)
  }, [jsSubLinea])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

        <div className="position-relative mx-1">
          <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxSubLinea({name, checked})}/>
        </div>

        <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                   placeholder="Buscar Sub Linea..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

      </div>

      <div className="my-2">
        {
            Object.keys(validObjectKeys(jsLinea)).map((item) => (
              <div className="container px-0">
                <div className="w-100 bg-gray-200 p-2 d-flex align-items-center justify-content-between">
                  <div className="font-weight-bold">
                    <CheckBox identificador={`${jsLinea[item]?.id}`} value={jsSubLinea[item]?.checked} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={``} onChange={({name, checked, label}) => handleChangeCheckBoxSubLinea({name, checked, label: jsLinea[item]?.name, checkAllSubLin: true})}/>
                    {jsLinea[item]?.name}
                  </div>
                  <i data-toggle="collapse" data-target={`#collapseSubLinea${jsLinea[item]?.id}`} aria-expanded="true" aria-controls={`#collapseSubLinea${jsLinea[item]?.id}`} className="fas fa-chevron-down fa-lg p-1 cursor-pointer"/>
                </div>
                <div className="row mx-3 px-0 my-3 collapse show" id={`collapseSubLinea${jsLinea[item]?.id}`}>
                  {
                    generalServicesState?.arrSubLineaProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map(itemSubLinea => (
                      <>
                        {
                          itemSubLinea?.idPadre === jsLinea[item]?.id &&
                          <div className={`${classResponsiveForm} mx-1`}>
                            <CheckBox identificador={itemSubLinea.id} label={itemSubLinea.text} value={!isEmpty(jsSubLinea[itemSubLinea.id])} styleLabel={{width: 130}} onChange={({name, checked, label}) => handleChangeCheckBoxSubLinea({name, checked, label})}/>
                          </div>
                        }
                      </>
                    ))
                  }
                </div>
              </div>
            ))
        }
      </div>
      <div className="row mx-3 px-0 mt-3 mb-2">

      </div>

    </div>
  )

}

const SubLinea = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsSubLinea = getValues('jsSubLinea');

    if(Object.keys(jsSubLinea)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 marca"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsSubLinea', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsSubLinea");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las sub lineas para asignar al portafolio</h4>

      <CheckBoxSubLinea />

    </div>
  )

}

const CheckBoxMarca = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsSubLinea = useWatch({
    control,
    name: 'jsSubLinea'
  });

  const jsMarca = useWatch({
    control,
    name: 'jsMarca'
  });

  const handleChangeCheckBoxMarca = ({name: id, checked, label, checkAllMarca}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsMarca', {});
        return;
      }

      let jsMarcaAll = {};

      for(let item of validArray(generalServicesState?.arrMarcaProductos)){
        if(!isEmpty(jsSubLinea[item.idPadre])) {
          jsMarcaAll[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      for(let itemMarca in validObjectKeys(jsSubLinea)){

        jsMarcaAll[itemMarca] = {
          id: jsSubLinea[itemMarca].id,
          name: jsSubLinea[itemMarca].name,
          checked: true,
          padre: true
        }

      }

      setValue('jsMarca', jsMarcaAll);

      return;
    }

    if(checkAllMarca){

      let jsMarcaCheckAllMarca = Object.assign({}, validObjectKeys(jsMarca));

      if(!checked){

        for(let item of validArray(generalServicesState?.arrMarcaProductos)){

          if(item.idPadre === id){
            for(let itemState in jsMarcaCheckAllMarca){
              if(item.id === itemState){
                delete jsMarcaCheckAllMarca[itemState];
              }
            }
          }

        }
        setValue('jsMarca', jsMarcaCheckAllMarca);
        return;
      }

      for(let item of validArray(generalServicesState?.arrMarcaProductos)){

        if(item.idPadre === id){
          jsMarcaCheckAllMarca[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      setValue('jsMarca', jsMarcaCheckAllMarca);


      return;
    }

    if(!checked){

      let jsMarcaClone = Object.assign({}, validObjectKeys(jsMarca));
      let i = 0;
      for(let item in jsMarcaClone){

        if(id === item){
          delete jsMarcaClone[item];
          break;
        }

        i++;
      }

      setValue('jsMarca', jsMarcaClone);

      return;
    }

    let jsMarcaClone = Object.assign({}, validObjectKeys(jsMarca));

    jsMarcaClone[id] = {id, checked, name: label};

    setValue('jsMarca', jsMarcaClone);

  }

  useEffect(() => {
    console.log(jsMarca)
  }, [jsMarca])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

        <div className="position-relative mx-1">
          <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxMarca({name, checked})}/>
        </div>

        <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                   placeholder="Buscar Sub Linea..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

      </div>

      <div className="my-2">
        {
          Object.keys(validObjectKeys(jsSubLinea)).map((item) => (
            <div className="container px-0">
              <div className="w-100 bg-gray-200 p-2 d-flex align-items-center justify-content-between">
                <div className="font-weight-bold">
                  <CheckBox identificador={`${jsSubLinea[item]?.id}`} value={jsMarca[item]?.checked} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={``} onChange={({name, checked, label}) => handleChangeCheckBoxMarca({name, checked, label: jsSubLinea[item]?.name, checkAllMarca: true})}/>
                  {jsSubLinea[item]?.name}
                </div>
                <i data-toggle="collapse" data-target={`#collapseMarcas${jsSubLinea[item]?.id}`} aria-expanded="true" aria-controls={`#collapseMarcas${jsSubLinea[item]?.id}`} className="fas fa-chevron-down fa-lg p-1 cursor-pointer"/>
              </div>
              <div className="row mx-3 px-0 my-3 collapse show" id={`collapseMarcas${jsSubLinea[item]?.id}`}>
                {
                  generalServicesState?.arrMarcaProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map(itemMarcas => (
                    <>
                      {
                        itemMarcas?.idPadre === jsSubLinea[item]?.id &&
                        <div className={`${classResponsiveForm} mx-1`}>
                          <CheckBox identificador={itemMarcas.id} label={itemMarcas.text} value={!isEmpty(jsMarca[itemMarcas.id])} styleLabel={{width: 130}} onChange={({name, checked, label}) => handleChangeCheckBoxMarca({name, checked, label})}/>
                        </div>
                      }
                    </>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
      <div className="row mx-3 px-0 mt-3 mb-2">

      </div>

    </div>
  )

}

const Marca = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsMarca = getValues('jsMarca');

    if(Object.keys(jsMarca)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 marca"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsMarca', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsMarca");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las marcas para asignar al portafolio</h4>

      <CheckBoxMarca />

    </div>
  )

}

const CheckBoxSubMarca = () => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [stateFilter, setStateFilter] = useState("");
  const { register, handleSubmit, formState: { errors }, control, setValue, getValues } = useFormContext();

  const jsMarca = useWatch({
    control,
    name: 'jsMarca'
  });

  const jsSubMarca = useWatch({
    control,
    name: 'jsSubMarca'
  });

  const handleChangeCheckBoxSubMarca = ({name: id, checked, label, checkAllSubMarca}) => {

    if(id === 'checkAll'){

      if(!checked){
        setValue('jsSubMarca', {});
        return;
      }

      let jsSubMarcaAll = {};

      for(let item of validArray(generalServicesState?.arrSubMarcaProductos)){
        if(!isEmpty(jsMarca[item.idPadre])) {
          jsSubMarcaAll[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      for(let itemSubMarca in validObjectKeys(jsMarca)){

        jsSubMarcaAll[itemSubMarca] = {
          id: jsMarca[itemSubMarca].id,
          name: jsMarca[itemSubMarca].name,
          checked: true,
          padre: true
        }

      }

      setValue('jsSubMarca', jsSubMarcaAll);

      return;
    }

    if(checkAllSubMarca){

      let jsSubMarcaCheckAllSubMarca = Object.assign({}, validObjectKeys(jsSubMarca));

      if(!checked){

        for(let item of validArray(generalServicesState?.arrSubMarcaProductos)){

          if(item.idPadre === id){
            for(let itemState in jsSubMarcaCheckAllSubMarca){
              if(item.id === itemState){
                delete jsSubMarcaCheckAllSubMarca[itemState];
              }
            }
          }

        }
        setValue('jsSubMarca', jsSubMarcaCheckAllSubMarca);
        return;
      }

      for(let item of validArray(generalServicesState?.arrSubMarcaProductos)){

        if(item.idPadre === id){
          jsSubMarcaCheckAllSubMarca[item.id] = {
            id: item.id,
            name: item.text,
            checked: true
          }
        }

      }

      setValue('jsSubMarca', jsSubMarcaCheckAllSubMarca);


      return;
    }

    if(!checked){

      let jsSubMarcaClone = Object.assign({}, validObjectKeys(jsSubMarca));
      let i = 0;
      for(let item in jsSubMarcaClone){

        if(id === item){
          delete jsSubMarcaClone[item];
          break;
        }

        i++;
      }

      setValue('jsSubMarca', jsSubMarcaClone);

      return;
    }

    let jsSubMarcaClone = Object.assign({}, validObjectKeys(jsSubMarca));

    jsSubMarcaClone[id] = {id, checked, name: label};

    setValue('jsSubMarca', jsSubMarcaClone);

  }

  useEffect(() => {
    console.log(jsSubMarca)
  }, [jsSubMarca])

  return(

    <div className="container" style={{border: "1px solid #EEEEEE", borderRadius: 5}}>

      <div className="d-flex justify-content-between align-items-end">

        <div className="position-relative mx-1">
          <CheckBox identificador={`checkAll`} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={`Seleccionar Todos`} onChange={({name, checked}) => handleChangeCheckBoxSubMarca({name, checked})}/>
        </div>

        <InputForm inputProps={{}} identificador="search" label="" value={stateFilter} handleChange={({name, value}) => setStateFilter(value)}
                   placeholder="Buscar Sub Marca..."  type="text"  className={`${classResponsiveFormDoubleWidth}`}/>

      </div>

      <div className="my-2">
        {
          Object.keys(validObjectKeys(jsMarca)).map((item) => (
            <div className="container px-0">
              <div className="w-100 bg-gray-200 p-2 d-flex align-items-center justify-content-between">
                <div className="font-weight-bold">
                  <CheckBox identificador={`${jsMarca[item]?.id}`} value={jsSubMarca[item]?.checked} styleCheck={{marginLeft: 0}} styleLabel={{marginLeft: "1.25rem"}} label={``} onChange={({name, checked, label}) => handleChangeCheckBoxSubMarca({name, checked, label: jsMarca[item]?.name, checkAllSubMarca: true})}/>
                  {jsMarca[item]?.name}
                </div>
                <i data-toggle="collapse" data-target={`#collapseSubMarcas${jsMarca[item]?.id}`} aria-expanded="true" aria-controls={`#collapseSubMarcas${jsMarca[item]?.id}`} className="fas fa-chevron-down fa-lg p-1 cursor-pointer"/>
              </div>
              <div className="row mx-3 px-0 my-3 collapse show" id={`collapseSubMarcas${jsMarca[item]?.id}`}>
                {
                  generalServicesState?.arrSubMarcaProductos?.filter(x => x?.text?.toString()?.toUpperCase().includes(stateFilter?.toString()?.toUpperCase()))?.map(itemSubMarcas => (
                    <>
                      {
                        itemSubMarcas?.idPadre === jsMarca[item]?.id &&
                        <div className={`${classResponsiveForm} mx-1`}>
                          <CheckBox identificador={itemSubMarcas.id} label={itemSubMarcas.text} value={!isEmpty(jsSubMarca[itemSubMarcas.id])} styleLabel={{width: 130}} onChange={({name, checked, label}) => handleChangeCheckBoxSubMarca({name, checked, label})}/>
                        </div>
                      }
                    </>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
      <div className="row mx-3 px-0 mt-3 mb-2">

      </div>

    </div>
  )

}

const SubMarca = ({id}) => {

  const dispatch = useDispatch();
  const { register, getValues, setValue } = useFormContext();

  const handleNextStep = () => {

    const jsSubMarca = getValues('jsSubMarca');

    if(Object.keys(jsSubMarca)?.length === 0){
      dispatch({type: 'setStateAlert', alert: {type: GlobalConstants.alertError, message: "Debe seleccionar almenos 1 marca"}});
      return;
    }

    Emitter.emit(ConstantEventEmitter.handleClickNextTabTracker, id)

  }

  const handleBackStep = () => {
    //setValue('jsSubMarca', {});
    Emitter.emit(ConstantEventEmitter.handleClickBackTabTracker, id);
  }

  useEffect(() => {
    register("jsSubMarca");
  },[])

  return(
    <div className="my-2 container">

      <div className="d-flex align-items-center justify-content-between py-2">
        <Tooltip title="Anterior" aria-label="anterior">
          <a onClick={() => handleBackStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-left fa-2x"/>
          </a>
        </Tooltip>
        <Tooltip title="Siguiente" aria-label="siguiente">
          <a onClick={() => handleNextStep()}
             className="icon-container-actions d-flex mx-0">
            <div style={{backgroundColor: Colors.COLOR_SKY_THEME}}/>
            <i style={{color: Colors.COLOR_SKY_THEME}} className="fas fa-arrow-right fa-2x"/>
          </a>
        </Tooltip>
      </div>

      <h4 className="py-2">Seleccione las sub marcas para asignar al portafolio</h4>

      <CheckBoxSubMarca />

    </div>
  )

}

const FormCRUDPortafolios = ({isEditing, isAddMode, properties}) => {

  const { data } = properties;
  const [stateTracker, setStateTracker] = useState([
    {id: 1, text: "Información", icon: "fas fa-pen", selected: true, completed: false, component: <Informacion id={1}/>},
    {id: 2, text: "Categoria", icon: "fas fa-sitemap", selected: false, completed: false, component: <Categorias id={2}/>},
    {id: 3, text: "Sub Categoria", icon: "fas fa-project-diagram", selected: false, completed: false, component: <SubCategorias id={3}/>},
    {id: 4, text: "Linea", icon: "fas fa-bars", selected: false, completed: false, component: <Linea id={4}/>},
    {id: 5, text: "SubLinea", icon: "fas fa-grip-lines", selected: false, completed: false, component: <SubLinea id={5}/>},
    {id: 6, text: "Marca", icon: "fas fa-clipboard-list", selected: false, completed: false, component: <Marca id={6}/>},
    {id: 7, text: "SubMarca", icon: "fas fa-clipboard-check", selected: false, completed: false, component: <SubMarca id={7}/>}
  ]);

  const methods = useForm({defaultValues: {
      jsCategorias: {},
      jsSubCategorias: {},
      jsLinea: {},
      jsSubLinea: {},
      jsMarca: {},
      jsSubMarca: {},
      dtFechaIniFin: getFechaToCalendarRange(data?.dtFechaIni ? data?.dtFechaIni : dateToStringFormat(new Date()), data?.dtFechaFin ? data?.dtFechaFin : '2200-12-31'),
  }});
  const { register, handleSubmit, formState: { errors }, control } = methods;

  const nextTabTracker = (idCurrentTab) => {

    let arrStateTrackerClone = stateTracker.slice();

    for(let item of arrStateTrackerClone){

      item.selected = false;
      if(item.id === idCurrentTab){
        item.completed = true;
      }
      if(item.id === (idCurrentTab + 1)){
        item.selected = true;
      }

    }

    setStateTracker(arrStateTrackerClone);

  }

  const backTabTracker = (idCurrentTab) => {

    let arrStateTrackerClone = stateTracker.slice();

    for(let item of arrStateTrackerClone){

      item.selected = false;
      if(item.id === idCurrentTab){
        item.completed = false;
      }
      if(item.id === (idCurrentTab - 1)){
        item.selected = true;
      }

    }

    setStateTracker(arrStateTrackerClone);

  }

  useEffect(() => {
    return () => {
      Emitter.off(ConstantEventEmitter.handleClickTabTracker);
      Emitter.off(ConstantEventEmitter.handleClickNextTabTracker);
    }
  }, [])

  useEffect(() => {
      Emitter.on(ConstantEventEmitter.handleClickTabTracker, (arrStateTrackerNew) => setStateTracker(arrStateTrackerNew));
      Emitter.on(ConstantEventEmitter.handleClickNextTabTracker, (idCurrentTab) => nextTabTracker(idCurrentTab));
      Emitter.on(ConstantEventEmitter.handleClickBackTabTracker, (idCurrentTab) => backTabTracker(idCurrentTab));
  }, [])

  return(
    <FormProvider {...methods} className="main_container">

      <div>

      </div>

      <Tracker steps={stateTracker}/>

    </FormProvider>
  )

}


export default FormCRUDPortafolios;
